import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/vote_bg_r.png'
import _imports_1 from '../../assets/vote_money_r.png'
import _imports_2 from '../../assets/vote_gift.png'
import _imports_3 from '../../assets/vote_line.png'
import _imports_4 from '../../assets/vote_cir.png'
import _imports_5 from '../../assets/vote_no.png'
import _imports_6 from '../../assets/vote_tips_font.png'


const _withScopeId = n => (_pushScopeId("data-v-d02ffb36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-col page" }
const _hoisted_2 = { class: "flex-row group" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"section_1\" data-v-d02ffb36></div><img src=\"" + _imports_0 + "\" class=\"image\" data-v-d02ffb36><div class=\"flex-col items-start image-wrapper\" data-v-d02ffb36><img src=\"" + _imports_1 + "\" class=\"image_1\" data-v-d02ffb36></div><img src=\"" + _imports_2 + "\" class=\"image_2\" data-v-d02ffb36>", 4)
const _hoisted_7 = { class: "flex-col section_2" }
const _hoisted_8 = { class: "flex-col items-center section_3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text_1" }, "最多可选5个", -1))
const _hoisted_10 = { class: "flex-col group_1" }
const _hoisted_11 = { class: "flex-col section_4" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"group_2\" data-v-d02ffb36><span class=\"text_2\" data-v-d02ffb36>距离投票结束还有</span><img src=\"" + _imports_3 + "\" class=\"image_3\" data-v-d02ffb36><img src=\"" + _imports_4 + "\" class=\"image_4\" data-v-d02ffb36><img src=\"" + _imports_4 + "\" class=\"image_5\" data-v-d02ffb36></div>", 1)
const _hoisted_13 = { class: "flex-col group_3" }
const _hoisted_14 = { class: "flex-row justify-center" }
const _hoisted_15 = { class: "block" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, "天", -1))
const _hoisted_17 = { class: "block" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, "时", -1))
const _hoisted_19 = { class: "block" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, "分", -1))
const _hoisted_21 = { class: "block" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, "秒", -1))
const _hoisted_23 = { class: "flex-col group_9" }
const _hoisted_24 = { class: "flex-col number_orders" }
const _hoisted_25 = { class: "group_12 flex-row" }
const _hoisted_26 = { class: "flex-col group_13" }
const _hoisted_27 = { class: "flex-row section_8" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "image_8"
}, null, -1))
const _hoisted_29 = { class: "text_16" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 提交 ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col section_rules" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text_14" }, "活动时间"),
  /*#__PURE__*/_createElementVNode("div", { class: "group_11" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("2022年4月6日中午12时起至2022年4月9日中午12时截止"),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text_14",
    style: {"margin-top":"0.44rem"}
  }, "投票规则"),
  /*#__PURE__*/_createElementVNode("div", { class: "group_11" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("1、每位用户每天可投一次，每次选取1-5条宣传语（最多5条，最少1条）"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("2、投票遵守诚实守信原则，严禁刷票，对违规刷票行为，主办方将清除“刷票”等原因的一切无效票。"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("3、最终结果由投票（50%）和专业评审（50%）综合评定，评选出前10名进行评审。"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("4、为奖励参与投票的粉丝，我们从中抽取50名幸运粉丝给予一份幸运礼。（抽奖仅限于我的丹阳app注册用户）"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "fontB" }, [
      /*#__PURE__*/_createTextVNode("活动解释权归丹阳市融媒体中心所有"),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ])
], -1))
const _hoisted_32 = { class: "flex-col section_statistics" }
const _hoisted_33 = { class: "flex-row width100" }
const _hoisted_34 = { class: "left-group flex-col items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/61930dd40163bf0011e5e679/6242d2a29d24e00011e78b60/16485466700315811837.png",
  class: "image_6"
}, null, -1))
const _hoisted_36 = { class: "text_7" }
const _hoisted_37 = { class: "text_16" }
const _hoisted_38 = { class: "right-group" }
const _hoisted_39 = { class: "text_18" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text_19" }, " 票", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col items-center image-wrapper_1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "image_21"
  })
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/61930dd40163bf0011e5e679/6242d2a29d24e00011e78b60/16485466691170126133.png",
  class: "image_22"
}, null, -1))
const _hoisted_43 = { class: "text_28" }
const _hoisted_44 = { class: "text_29" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_van_count_down, {
                    time: _ctx.voteDatas.lastTime
                  }, {
                    default: _withCtx((timeData) => [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(timeData.days), 1),
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(timeData.hours), 1),
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, _toDisplayString(timeData.minutes), 1),
                      _hoisted_20,
                      _createElementVNode("span", _hoisted_21, _toDisplayString(timeData.seconds), 1),
                      _hoisted_22
                    ]),
                    _: 1
                  }, 8, ["time"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_van_tabs, {
                    active: _ctx.active,
                    "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.active) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_tab, { title: "宣传标语" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_van_checkbox_group, {
                              modelValue: _ctx.checked,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
                              onChange: _ctx.groupclick,
                              max: 5
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_cell_group, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voteDatas.items, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_van_cell, {
                                        key: index,
                                        clickable: "",
                                        "data-name": item
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_van_checkbox, {
                                            name: item,
                                            "checked-color": "#ee0a24",
                                            ref_for: true,
                                            ref: "checkboxes"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_25, [
                                                _createElementVNode("div", _hoisted_26, [
                                                  _createElementVNode("div", _hoisted_27, [
                                                    _createElementVNode("span", null, _toDisplayString(item.voteItemInfo), 1)
                                                  ]),
                                                  _hoisted_28,
                                                  _createElementVNode("span", _hoisted_29, _toDisplayString(item.voteItemNo), 1)
                                                ])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"])
                                        ]),
                                        _: 2
                                      }, 1032, ["data-name"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _createVNode(_component_van_button, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveVoteInfo())),
                            class: "saveButton",
                            block: "",
                            color: "linear-gradient(to right, #ff6034, #ee0a24)"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_30
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_tab, { title: "规则详情" }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_tab, { title: "投票统计" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_van_pull_refresh, {
                              modelValue: _ctx.loading,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
                              onRefresh: _ctx.onRefresh
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voteDatas.items, (countItem, countIdx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "justify-between myMargin",
                                    key: countIdx
                                  }, [
                                    _createElementVNode("div", _hoisted_33, [
                                      _createElementVNode("div", _hoisted_34, [
                                        _hoisted_35,
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(countItem.voteItemNo), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_37, _toDisplayString(countItem.voteItemInfo), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(countItem.voteItemNum), 1),
                                      _hoisted_40
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onRefresh"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["active"])
                ])
              ])
            ]),
            _hoisted_41
          ])
        ])
      ]),
      _hoisted_42,
      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.voteTitle_t), 1),
      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.voteTitle_p), 1)
    ])
  ]))
}